
export const normalize = (str: string) =>
    str
      .trim() 
      .replace(/\s+/g, ' ')
      .toLowerCase();